import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthorizeService } from '../../shared/services/authorize.service';
import { take } from 'rxjs';
import { map } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthorizeService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authService.authNavStatus$.pipe(
      take(1),
      map((isAuthenticated) => {
        if (!isAuthenticated) {
          return this.router.createUrlTree(['/account/login'], {
            queryParams: { redirect: state.url },
          });
        }

        const user = this.authService.user; // Obtén al usuario actual
        if (!user) return false;

        const requiredRoles = route.data['roles'] as string[]; // Obtén los roles requeridos del route

        if (
          user &&
          requiredRoles.some((role) =>
            user?.profile?.['permissions'].includes(role)
          )
        ) {
          return true; // Usuario tiene acceso
        }

        // Redirige si no tiene acceso
        this.router.navigate(['/not-authorized']);
        return false;
      })
    );
  }
}
